<template lang="pug">
.menu
	ul
		li(v-for="item in menu", :key="item.url", @click="irSeccion(item)", :class="($route.path === item.url || item.activo) ? 'active' : ''")
			span(:class="item.icono")
			.titulo {{item.nombre}}
</template>


<script>
export default {
	props: ['menu', 'defecto'],
	methods: {
		irSeccion (item) {
			if (item.url) {
				this.$router.push(item.url)
			} else if (item.callback) {
				item.callback(item)
			}
		}
	}
}
</script>

<style scoped>
	.menu {
		position: relative;
		display: block;
		margin-top: -20px;
		overflow-x: auto;
		margin-bottom: 10px;
		background-color: #f0f0f0;
		border-bottom: 1px solid #e0e0e0;
		box-shadow: 0 2px 5px rgba(0,0,0,0.2);
	}
	.menu > ul {
		position: relative;
		display: table;
		margin: 0;
		padding: 0;
		/*width: 100%;*/
	}

	.menu > ul > li {
		position: relative;
		display: table-cell;
		text-align: center;
		height: 50px;
		padding: 5px;
		padding-top: 10px;
		max-width: 90px;
		width: 90px;
		margin: 5px;
		vertical-align: top;
		cursor: pointer;
	}

	.menu > ul > li > span {
		font-size: 2em;
	}

	.menu > ul > li > div.titulo {
		font-size: 1em;
	}

	.menu > ul > li:hover {
		background-color: #777777;
		color: white;
	}

	.menu > ul > li.active {
		background-color: #f9f9f9;
		font-weight: bold;
		color: #444444;
		border-bottom: 2px solid #666666;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/menu-superior/menu-superior.vue